import { useEffect, useContext, useState, FormEvent } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import Spinner from "../../../../../shared/components/spinner/spinner";
import AuthContext from "../../../../../shared/context/auth-context";
import useHttp from "../../../../../shared/hooks/use-http";
import { postSingle } from "../../../../../shared/utils/api";
import { noop } from "../../../../utils";
import ControlledTable, {
  IColumn,
} from "../../../controlled-table/controlled-table";
import { ITableRowData } from "../../../data-table/data-table";


const alertcaseColumns: IColumn[] = [
  {
    key: "alertcase_number",
    displayName: "AlertCase ID",
    dataType: {
      type: "text",
    },
  },
  {
    key: "title",
    displayName: "Title",
    dataType: {
      type: "text",
    },
  },
  {
    key: "creation_date",
    displayName: "Creation date",
    dataType: {
      type: "dateTime",
    },
  },
  {
    key: "process_type",
    displayName: "Process type",
    dataType: {
      type: "text",
    },
  },
  {
    key: "domain_type",
    displayName: "Domain type",
    dataType: {
      type: "text",
    },
  },
  {
    key: "consolidate_on_entity_type",
    displayName: "Consolidation",
    sortable: false,
    dataType: {
      type: "text",
    },
  },
  {
    key: "current_stage_name",
    displayName: "Stage",
    dataType: {
      type: "text",
    },
  },
  {
    key: "last_changed_by_name",
    displayName: "Last changed by",
    sortable: false,
    dataType: {
      type: "text",
    },
  },
  {
    key: "state",
    displayName: "Status",
    dataType: {
      type: "text",
    },
  },
];

export interface IPopupLinkedAlertcasesConfig {
  show: boolean;
  alertcaseRowId?: string;
  selectedId: string;
  eventId: string;
  handlePopupClosed(result: ITableRowData[] | undefined): void;
}

const LinkedAlertcasesModal = ({
  show,
  alertcaseRowId,
  selectedId,
  eventId,
  handlePopupClosed,
}: IPopupLinkedAlertcasesConfig) => {
  const [validated, setValidated] = useState(false);
  const [data, setData] = useState<ITableRowData[]>([]);
  const authCtx = useContext(AuthContext);
  const {
    sendRequest: postLinkData,
    status: postLinkDataStatus,
    error: postLinkDataError,
    data: postLinkDataResult,
  } = useHttp(
    postSingle,
    true,
    authCtx.token,
    "getAlertcasesByEvent",
    "manager"
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (show && alertcaseRowId && eventId && selectedId) {
      postLinkData("get_alertcases_by_event", {
        event_type_id: eventId,
        event_id: selectedId,
      }, undefined, "none");
    }
  }, [show]);

  useEffect(() => {
    if (
      postLinkDataStatus === "completed" &&
      !postLinkDataError &&
      postLinkDataResult
    ) {
      setData(postLinkDataResult);
    }
  }, [postLinkDataStatus, postLinkDataResult, postLinkDataError]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValidated(true);
  };
  return (
    <div>
      <Modal
        className="UserPopup"
        show={show}
        onHide={() => handlePopupClosed(undefined)}
      >
        {postLinkDataStatus === "pending" && <Spinner />}
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Linked Alertcases</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ControlledTable
              allowSelectAll={false}
              style="compact"
              title={"Related alertcases"}
              data={data}
              selectionMode="off"
              columns={alertcaseColumns}
              onSorted={noop}
              onScroll={noop}
              onRowClick={(id: string) => {
                navigate(`/manager/alertcases/${id}`);
                window.location.reload();
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => handlePopupClosed(undefined)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default LinkedAlertcasesModal;
